import './index.css';
import { I18nextProvider } from 'react-i18next';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { persistReducer, persistStore } from 'redux-persist';
import { render } from 'react-dom';
import React from 'react';
import i18n from 'i18next';
import moment from 'moment';
import stateReconciler from 'redux-persist/lib/stateReconciler/autoMergeLevel1';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import xhr from 'i18next-xhr-backend';
import reducer from './reducer/reducer';
import registerServiceWorker from './registerServiceWorker';
import App from './components/app/App';

const isDevelopment = process.env.NODE_ENV === 'development';

const i18nInstance = i18n.use(xhr).init({
  fallbackLng: 'en',
  preload: ['en'],
  // debug: isDevelopment,
  debug: false,
  backend: {
    loadPath: 'locales/{{lng}}.json',
    crossDomain: false,
  },
  react: {
    wait: true,
  },
  interpolation: {
    format: (value, format) => {
      if (typeof value === 'string' && moment(value).isValid()) {
        return moment(value).format(format);
      }
      return value;
    },
  },
}, () => {
  const persistedReducer = persistReducer({
    key: 'root',
    storage,
    stateReconciler,
    whitelist: ['session', 'presistFilters'],
  }, reducer);

  const middleware = applyMiddleware(thunk);
  const composeEnhancers = composeWithDevTools({
    trace: true,
  });
  const store = createStore(persistedReducer, isDevelopment
    ? composeEnhancers(middleware) : middleware);
  const persistor = persistStore(store);

  render(
    <I18nextProvider i18n={i18nInstance}>
      <Provider store={store}>
        <PersistGate loading={null}
          persistor={persistor}
        >
          <App />
        </PersistGate>
      </Provider>
    </I18nextProvider>,
    document.getElementById('root'),
  );

  registerServiceWorker();
});
